
import { Spain } from "../_Translate/Spain";
import { English } from "../_Translate/English";

export const HAS__MODULE_RESOURCE_API = false;

const TRANSLATE = { es: Spain, en: English };

export const onModuleContent = (lang = "es") => (TRANSLATE[lang] ?? Spain).MODULE;

export const MODULE_CONTENT = onModuleContent();
